import { render } from "./LocationSettings.vue?vue&type=template&id=35cd11d0&ts=true"
import script from "./LocationSettings.ts?vue&type=script&lang=ts&external"
export * from "./LocationSettings.ts?vue&type=script&lang=ts&external"

import "./LocationSettings.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__